import gql from 'graphql-tag';

const LINKS_GET = gql`
  query getLinks {
    getLinksResponse
      @rest(
        type: "GetLinks"
        path: "/links/links/"
        method: "GET"
      ) {
      pk: id
      name: friendly_name
      type
      url
      file
      comments
      created
      modified
    }
  }
`;

const SECTIONS_GET = gql`
  query getSections {
    getSectionsResponse
      @rest(
        type: "GetSections"
        path: "/links/sections/"
        method: "GET"
      ) {
      pk: id
      name
      index
      resources
    }
  }
`;

export default {
  LINKS_GET, SECTIONS_GET
};